/**
 * Created by eliasmj on 07/07/2015.
 */
angular.module('qkr').directive('capitalize', (_) => ({
        require: 'ngModel',
        link(scope, element, attrs, modelCtrl) {
            const capitalize = function(inputValue) {
                if (_.isEmpty(inputValue)) {
                    return;
                }

                const capitalized = inputValue.toUpperCase();

                if (capitalized !== inputValue) {
                    modelCtrl.$setViewValue(capitalized);
                    modelCtrl.$render();
                }
                return capitalized;
            };

            modelCtrl.$parsers.push(capitalize);
            capitalize(scope[attrs.ngModel]);  // Capitalize initial value
        }
    }));



// WEBPACK FOOTER //
// ./src/directives/capitalize.js